import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/404.png'


const _withScopeId = n => (_pushScopeId("data-v-4d14f4b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Img"
}, null, -1))
const _hoisted_3 = { class: "title" }

import { store } from '@/store/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const Store = store();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? 'გვერდი ვერ მოიძებნა' : 'Page not found') + " :(", 1)
  ]))
}
}

})